import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { SliderThumb, SliderTypeMap } from '@mui/material';
import React, { PropsWithChildren } from 'react';
import { makeStyles } from 'tss-react/mui';

type SliderThumbProps = PropsWithChildren<NonNullable<SliderTypeMap['props']['componentsProps']>['thumb']>;

export const ThumbComponent: React.FC<SliderThumbProps> = (props) => {
	const { children, ...other } = props;
	const { classes } = useStyles();
	return (
		<SliderThumb {...other}>
			{children}
			<ArrowLeftIcon color='inherit' className={classes.arrowLeft}></ArrowLeftIcon>
			<ArrowRightIcon color='inherit' className={classes.arrowRight}></ArrowRightIcon>
		</SliderThumb>
	);
};

const useStyles = makeStyles({ name: { ThumbComponent } })(() => ({
	arrowLeft: {
		marginRight: -8
	},
	arrowRight: {
		marginLeft: -8
	}
}));
